module.exports = __webpack_public_path__ + "static/img/logo_color.2abf089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base/logo_color.png
// module id = t49S
// module chunks = 6